import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from "@tanstack/react-query";

import {
  ackIncident,
  listIncidents,
  resolveIncident,
  type Incident,
  type IncidentsListParams,
} from "@/lib/api";

export const incidentsKeys = {
  all: ["incidents"] as const,
  list: (params?: IncidentsListParams) =>
    [...incidentsKeys.all, "list", params] as const,
};

export function useIncidents(
  params?: IncidentsListParams,
): UseQueryResult<Incident[], Error> {
  return useQuery({
    queryKey: incidentsKeys.list(params),
    queryFn: () => listIncidents(params),
  });
}

export function useAckIncident(): UseMutationResult<Incident, Error, number> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => ackIncident(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: incidentsKeys.all });
      qc.invalidateQueries({ queryKey: ["stats"] });
    },
  });
}

export function useResolveIncident(): UseMutationResult<
  Incident,
  Error,
  number
> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => resolveIncident(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: incidentsKeys.all });
      qc.invalidateQueries({ queryKey: ["stats"] });
    },
  });
}
